import { render } from "./Page404.vue?vue&type=template&id=4a2d4ae6"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"

import "./Page404.vue?vue&type=style&index=0&id=4a2d4ae6&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__